import { pumpApi } from '@libs/openapi';
import { OpenapiClientPump } from 'foca-openapi';
import { useEffect, useState } from 'react';

export const usePumpRankingChanges = (limit: number = 20) => {
  const [loading, setLoading] = useState(false);
  const [rankingChanges, setRankingChanges] =
    useState<OpenapiClientPump.GetRankingsChangesResponse>();

  const getRankingChanges = async () => {
    setLoading(true);
    const result = await pumpApi.ranking.getRankingsChanges({
      query: {
        limit,
      },
    });
    setRankingChanges(result);
    setLoading(false);
  };
  useEffect(() => {
    getRankingChanges();
  }, [limit]);

  return {
    rankingChanges,
    loading,
  };
};
